import { ThunkType } from "../../../../core/store/reducers";
import { getMonthlyClientExcel } from "../api/getMonthlyClientExcel";
import fileDownload from "js-file-download";
import { setFetchState } from "../monthlyTradeDataSlice";
import moment from "moment";

export const downloadMonthlyClientExcel = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.reports.monthlyTrade;
  const user = store.data.auth.current.user;
  dispatch(setFetchState({ type: "started" }));

  const monthlyTrading = await dispatch(getMonthlyClientExcel(user, filter));
  if (monthlyTrading) {
    fileDownload(
      new Blob([monthlyTrading as any], {
        type: "application/vnd.openxmlformat",
      }),
      "MonthlyCTrading_" + moment().format("YYYYMMDDhhmmss") + ".xlsx"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};
